import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_ConvexHull_Grahams = () => (
  <DAAModuleSubtopic
    title="Convex Hull - Graham Scan"
    videos={[
      "https://www.youtube.com/embed/5D9F1HA6-f4",
      "https://www.youtube.com/embed/QYrpHE8iDGg",
      "https://www.youtube.com/embed/B2AJoQSZf4M",
      "https://www.youtube.com/embed/SBdWdT_5isI",
    ]}
    takeaways={[
      { text: "Overall time complexity is O(n log n) – primarily due to sorting the points by polar angle." },
      { text: "Step 1: Find the lowest point (with the smallest y-coordinate; in case of tie, the leftmost x-coordinate)." },
      { text: "Step 2: Sort points based on the polar angle with respect to the base point." },
      { text: "Step 3: Use a stack to build the convex hull." },
      { text: "Step 4: Traverse sorted points and determine left or right turns using the cross product." },
      { text: "Step 5: Pop points from the stack that would make a right turn (not part of the convex hull)." },
      { text: "Edge Case:  All points are collinear → convex hull is just the two endpoints." },
      { text: "Edge Case: Duplicate points should be removed before processing." },
      { text: "Edge Case: Precision issues may require handling for floating-point calculations." },
      { image: "/Grahams scan.png",}
    ]}
    questions={[
      {
        text: "Given the following set of points 'P' in a plane. Construct the smallest polygon Q such that every point in 'P' is either on the boundary or inside the polygon. Use Graham's Scan Algorithm to wrap the points in counter-clockwise direction: (2,1), (3,3), (5,4), (-2,2), (-3,1), (-4,3), (-1,-2), (-3,-4), (2,-3), (4,-4)."
      },
      {
        text: "Relate Graham's Scan and Jarvis March Algorithm steps. Discuss how to choose the best practices for computational Convex Hull. Illustrate with an example."
      },
      {
        text: "In robotics, path-planning is crucial for efficient navigation. A robot vacuum must clean the edges of a room. How can the Graham Scan algorithm determine the most efficient cleaning path along the room's perimeter? Given coordinates: {(-3,-4), (2,-3), (4,3), (-4,2), (0,5), (2,-3), (-1,4)}."
      }
    ]}
    exampleVideos={[
      "https://www.youtube.com/embed/vfuVa0FJu5M"
    ]}
  />
);

export default DAA_ConvexHull_Grahams ;
